export default {
  // STATE
  tableMode: false,
  detailsIsActive: false,
  detailsId: null,
  filtersTabIsActive: false,
  preferencesModalIsActive: false,
  preferencesId: null,

  // FILTERS
  searchFilter: undefined,
  activeFilters: {},
};
